export const SET_ALL_UNITS = 'SET_ALL_UNITS';
export const SET_ALL_GROUPUNITS_ON_UNITS = 'SET_ALL_GROUPUNITS_ON_UNITS';
export const SET_LOADING_ON = 'SET_LOADING_ON';
export const SET_LOADING_OFF = 'SET_LOADING_OFF';
